import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ShareGiftCard = lazyWithPreload(() => import('./ShareGiftCard'))
